import React, {FC, useEffect} from 'react'
import {PageLink, PageTitle, useLayout} from '../../../_payairo/layout/core'
import AllUsers from './AllUsers'

const UserManagementWrapper: FC = () => {
  const {setRightTolbar} = useLayout()

  useEffect(() => {
    setRightTolbar('usermanagement')
    return () => setRightTolbar('')
  }, [setRightTolbar])

  return (
    <>
      <AllUsers />
    </>
  )
}

const myBreadCrumbs: PageLink[] = [
  {title: 'Home', path: '/dashboard', isSeparator: false, isActive: false},
  {title: '', path: '', isSeparator: true, isActive: false},
]

export {UserManagementWrapper}
